/*
 * @Author: xiwl
 * @Date: 2021-11-08 09:39:32
 * @LastEditors: xiwl
 * @LastEditTime: 2022-06-29 13:56:15
 * @Descripttion: 登录页
 */
import React, { Component } from 'react';
import { Button, message, Icon } from 'antd';
import axios from 'axios';
import styles from './index.less';
import Checking from '../checking';

let origin = window.location.origin;

if (origin === 'http://localhost:3000' || origin === 'http://127.0.0.1:3000') {
  origin = 'http://10.131.0.4:32075';
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      globalLoading: false,
      count: 60,
      loading: false,
      disabled_btn: false,
      mobilePhone: '',
      loginBgMp4: '../../assets/images/login.mp4',
    };
  }
  onChangeForm = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if (!value) {
      if (name === 'userName') {
        this.setState({
          loginErrorUserName: true,
        });
      }
      if (name === 'pwd') {
        this.setState({
          loginErrorPwd: true,
        });
      }
    } else {
      this.setState({ loginErrorUserName: false, loginErrorPwd: false });
    }
  };
  getCode = (e) => {
    e.preventDefault();
    let form = this.refs.loginForm || {};
    let userName = form['userName'].value;
    if (!userName) {
      message.error('请先输入用户名！');
      return;
    } else {
      axios
        .get(
          `${
            window.globalConfig.path || origin
          }/console/console/v2/srm/get/mobilePhone?loginName=${userName}`,
          null,
          { headers: { ServiceName: 'console' } }
        )
        .then((r) => {
          if (r && r.data) {
            if (r.data.success && r.data.data) {
              this.setState({ mobilePhone: r.data.data });
              axios
                .post(
                  `${
                    window.globalConfig.path || origin
                  }/console/console/v2/login/sms/get-verify-code`,
                  { mobile: r.data.data },
                  { headers: { ServiceName: 'console' } }
                )
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    message.success(
                      `验证码已发送至${r.data.data}，请注意查收！`
                    );
                    let { count } = this.state;
                    this.timer = setInterval(() => {
                      this.setState(
                        {
                          count: count--,
                          disabled_btn: true,
                        },
                        () => {
                          if (count === 0) {
                            clearInterval(this.timer);
                            this.setState({
                              count: 60,
                              disabled_btn: false,
                            });
                          }
                        }
                      );
                    }, 1000);
                  } else {
                    message.error(res.data.message);
                  }
                });
            } else {
              message.error(r.data.message || '用户名错误，请重新输入！');
            }
          }
        });
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();
    let { mobilePhone } = this.state;
    let form = this.refs.loginForm || {};
    let userName = form['userName'].value;
    let pwd = form['pwd'].value;
    if (!userName) {
      this.setState({ loginErrorUserName: true });
    }
    if (!pwd) {
      this.setState({ loginErrorPwd: true });
    }
    if (userName && pwd) {
      this.setState({ loading: true });
      axios
        .post(
          `${
            window.globalConfig.path || origin
          }/console/console/v2/login/sms/login`,
          { mobile: mobilePhone, verifyCode: pwd },
          {
            headers: { ServiceName: 'console' },
          }
        )
        .then((res) => {
          if (res.data.success) {
            window.location.href = res.data.message;
          } else {
            message.error(res.data.message);
          }
          this.setState({ loading: false });
        })
        .catch((error) => {
          this.setState({ loading: false });
        });
    }
  };
  // 供应商自注册前 验证功能
  beforeRegist = (e) => {
    e.stopPropagation();
    let { captchaShow } = this.state;
    this.setState({ captchaShow: !captchaShow });
  };
  // 供应商自注册
  inviteRegist = () => {
    axios
      .get(`${window.globalConfig.path || origin}/pur/supplier/regist/address`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          window.open(res.data.data);
          this.setState({ captchaShow: false });
        }
      });
  };
  render() {
    let {
      count,
      loginErrorUserName,
      loginErrorPwd,
      loading,
      disabled_btn,
      captchaShow,
      loginBgMp4,
    } = this.state;

    return (
      <div className={styles.content}>
        <div className={styles.poster}>
          <video
            style={{
              'object-fit': 'fill',
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: '0',
            }}
            autoPlay
            loop
            muted
            src={require('../../assets/images/login.mp4')}
          ></video>
          <div className={styles.loginBGWrapper}>
            <div className={styles.loginBGTitle}>推动企业管理进步</div>
            <div className={styles.loginBGDescribe}>
              Better Management，Better Enterprise
            </div>
          </div>
          {/* <img
            src={[require('../../assets/images/login.gif')]}
            width='100%'
            height='100%'
          /> */}
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.formContainer}>
            <h4 className={styles.formTitle}>供应商登录</h4>
            {!captchaShow ? (
              <form ref='loginForm'>
                <div style={{ position: 'relative' }}>
                  <Icon type='user' className={styles.prefix_input} />
                  <input
                    name='userName'
                    className={styles.normal_input}
                    style={{ borderColor: loginErrorUserName ? '#f5222d' : '' }}
                    id='e_username'
                    type='text'
                    placeholder='用户名'
                    onChange={this.onChangeForm}
                  />
                </div>
                {loginErrorUserName ? (
                  <span style={{ color: '#f5222d', textIndent: '1em' }}>
                    请输入用户名
                  </span>
                ) : null}
                <div style={{ position: 'relative' }}>
                  <Button
                    disabled={disabled_btn}
                    className={styles.suffix}
                    onClick={this.getCode}
                  >
                    获取验证码{disabled_btn ? `（${count}秒）` : null}
                  </Button>
                  <Icon type='calculator' className={styles.prefix_input} />
                  <input
                    name='pwd'
                    id='e_password'
                    className={styles.normal_input}
                    style={{ borderColor: loginErrorPwd ? '#f5222d' : '' }}
                    onChange={this.onChangeForm}
                    placeholder='验证码'
                  />
                </div>
                {loginErrorPwd ? (
                  <span style={{ color: '#f5222d', textIndent: '1em' }}>
                    请输入验证码
                  </span>
                ) : null}
                {/* <div className={styles.forget_psd}>
                                <span>忘记密码?</span>
                            </div> */}
                <div>
                  <Button
                    type='primary'
                    onClick={this.handleSubmit}
                    className={styles.login_form_button}
                    loading={loading}
                  >
                    登录
                  </Button>
                </div>
              </form>
            ) : (
              <Checking />
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                height: '40px',
                lineHeight: '40px',
              }}
            >
              {/* <a onClick={this.beforeRegist} style={{'width': 'fit-content', userSelect: 'none'}}>
                            {!captchaShow ? '供应商自注册' : '<<返回登录'}
                        </a> */}
              {captchaShow ? (
                <a
                  onClick={this.beforeRegist}
                  style={{ width: 'fit-content', userSelect: 'none' }}
                >
                  {'<<返回登录'}
                </a>
              ) : null}
              {captchaShow && <span>安全验证</span>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;